import React from 'react';
import './App.css';
import Attributes from './attributes';
import githubLogo from './images/logos/organizations/githubLogo.png';

function openTab(link: string, newTabFlag: boolean) {
  if (newTabFlag) {
    window.open(
      link,
      '_blank'
    );
  } else {
    window.open(
      link,
      '_self'
    );
  }

}

function projects(props: any) {

  function changeURL(page: string) {
    // console.log(page);
    window.location.href = page;
  }

  function openDocument() {
    // window.location.href = "public/documents/Thesis.pdf"
    window.open("public/documents/Thesis.pdf", "_blank", "fullscreen=yes");
    // window.open("https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", "_blank");
  }

  function createButtons(button1: any, button2: any, externalSiteLink:any, repoLink: any, pdfLink: any,onGoing:any) {

    var logo = React.createElement("img", { className: "smallImage", src: githubLogo }, null)

    var b1;
    if (false) {
      b1 = React.createElement("button", { className: "cardButton", onClick: () => changeURL(props.url) },
        'Read More'
      )
    }

    var b2;
    // console.log("Button2:" + button2);



    if (pdfLink) {
      b2 = React.createElement("button", { className: "cardButton", onClick: () => openTab(pdfLink, true) },
        'Download PDF'
      )
    }

    var b3;
    if (repoLink) {
      b3 = React.createElement("button", { className: "cardButton", onClick: () => openTab(repoLink, true) },
        logo
      )
    }

    var b4;
    if (externalSiteLink) {
      b4 = React.createElement("button", { className: "cardButton", onClick: () => openTab(externalSiteLink, true) },
        'See External Site'
      )
    }


    var b5;
    // var allowContact = true;
    if (onGoing == "Ongoing") {
      b5 = React.createElement("button", { className: "cardButton", onClick: () => openTab("mailto:cspowell5438@gmail.com", false) },
        'Contact About Project'
      )
    }



    var e = React.createElement("div",
      { className: 'projectButtons' },
      b1,
      b2,
      b3,
      b4,
      b5
    );

    return (e);
  }

  function currentStatus(status : string){
    if(status == "Ongoing"){
      return(<span className="status-Ongoing" >{status}</span>)
    } else if (status == "Completed"){
      return(<span className="status-Complete">{status}</span>)
    } 
  }

  return (
    <div className="projectBox">
      <div className="projectTopper">
        <video onClick={()=> props.handleClick()}poster={props.imgPath} src={props.info.vidPath} autoPlay muted loop>
        </video>
      </div>

      <div className="project">
        
        <div className="projectTitle">
          <h1>{props.title}</h1>
           
          <h2>{props.subtitle}</h2>
           <div className="projectAttributeWrapper">
              <Attributes info={props.info}></Attributes>
              <h3 className="projectDate"> {currentStatus(props.info.current_status)} | {props.info.month} {props.info.year}</h3>
            </div>
          {/* <Attributes info={props.info}></Attributes> */}
        </div>

        <div className="projectText">
          <p> {props.text}
          </p>
        </div>
      </div>
      {
        createButtons(props.url, props.externalResource, props.info.externalSiteLink,props.info.repositoryLink, props.info.pdfLink,props.info.current_status)
      }
    </div>

  );
}

export default projects;
